import { render } from "./BarrierDiagramByQuarter.vue?vue&type=template&id=12661912&scoped=true"
import script from "./BarrierDiagramByQuarter.vue?vue&type=script&lang=js"
export * from "./BarrierDiagramByQuarter.vue?vue&type=script&lang=js"

import "./BarrierDiagramByQuarter.vue?vue&type=style&index=0&id=12661912&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12661912"]])

export default __exports__